// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30_Q_","col":"styles_col__XGF2k"};